import * as React from "react";
import { Rect } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Lainnya = (props: IIconProps) => (
  <Icon viewBox="0 0 28 28" {...props}>
    <Rect
      x="2.47058"
      y="2.4707"
      width="10.4132"
      height="10.4132"
      rx="5.20662"
      fill="#FD6542"
    />
    <Rect
      x="2.47057"
      y="15.488"
      width="10.4133"
      height="10.4133"
      rx="5.20663"
      fill="#46BFAE"
    />
    <Rect
      x="15.4878"
      y="2.4707"
      width="10.4133"
      height="10.4133"
      rx="5.20663"
      fill="#FFB207"
    />
    <Rect
      x="15.4878"
      y="15.488"
      width="10.4133"
      height="10.4133"
      rx="5.20663"
      fill="#5786CC"
    />
  </Icon>
);

export default Lainnya;
